import React, { Component } from 'react'
import styles from './works.styles'
import injectSheet from 'react-jss'
import Container from '../../shared/container/container'
import Main from '../../shared/main/main'
import Paper from 'pobble-components/dist/paper'
import SectionTitle from '../../shared/section-title/section-title'
import WorksFilters from './works-filters/works-filters.container'
import WorksList from './works-list/works-list.container'
import Spinner from 'pobble-components/dist/spinner'

class Works extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  componentDidUpdate(prevProps) {
    this.props.onUpdate(prevProps)
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Container>
        <Main>
          <Paper className={classes.container}>
            <SectionTitle title="Works" />
            <WorksFilters />
            {pending && <Spinner className={classes.spinner} />}
            {!pending && <WorksList />}
          </Paper>
        </Main>
      </Container>
    )
  }
}

export default injectSheet(styles)(Works)
